import React, { Component } from 'react'
import { ForgetPassword } from '../../action/auth';
import Forgot from '../../old_Components/ForgotPassword/ForgotPassword'
import constant from '../../constant';
import Swal from 'sweetalert2';

export default class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false
        }
    }
    componentDidMount() {
        document.title = constant.title.ForgetPassword
    }

    onSubmit = (model) => {
        this.setState({ showLoader: true })
        ForgetPassword(model).then(res => {
            if (res.status) {
                this.setState({ showLoader: false })
                Swal.fire({
                    icon: 'success',
                    text: "An email has been sent to your email. Please click on the link provided in the email to reset your password.",
                    timer: 1500,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            window.location.reload()    
            }
            else {
                this.setState({ showLoader: false })

                Swal.fire({
                    icon: 'error',
                    text: res.error,
                    timer: 1000,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
        })
    }
    render() {
        return (
            <React.Fragment>
                <Forgot
                    onSubmit={this.onSubmit}
                    showLoader={this.state.showLoader}
                />

            </React.Fragment>
        )
    }
}
